import React from 'react';
import { UserLayout } from '../../components/Layout/UserLayout';
import { LayoutDashboard, TrendingUp, DollarSign, SproutIcon, Wallet, ArrowUpRight, ArrowDownRight, CalendarIcon, Search, LineChart } from 'lucide-react';
export const InvestorDashboardPage = () => {
  // Sample data for investor dashboard
  const portfolioStats = [{
    title: 'Total Investments',
    value: 'RM 450,000',
    change: '+12%',
    isPositive: true,
    icon: <Wallet size={20} className="text-blue-600" data-id="element-839" />
  }, {
    title: 'Active Projects',
    value: '5',
    change: '+1',
    isPositive: true,
    icon: <SproutIcon size={20} className="text-green-600" data-id="element-840" />
  }, {
    title: 'Total Returns',
    value: 'RM 68,500',
    change: '+8%',
    isPositive: true,
    icon: <DollarSign size={20} className="text-amber-600" data-id="element-841" />
  }, {
    title: 'Projected ROI',
    value: '15.2%',
    change: '+0.4%',
    isPositive: true,
    icon: <TrendingUp size={20} className="text-purple-600" data-id="element-842" />
  }];
  const activeInvestments = [{
    id: 1,
    name: 'Sustainable Rice Farming',
    farmer: 'Ahmad Ismail',
    location: 'Kedah',
    invested: 'RM 120,000',
    progress: 70,
    returns: 'RM 18,000'
  }, {
    id: 2,
    name: 'Vertical Farming Technology',
    farmer: 'Mei Lin',
    location: 'Selangor',
    invested: 'RM 150,000',
    progress: 50,
    returns: 'RM 22,500'
  }, {
    id: 3,
    name: 'Aquaculture System',
    farmer: 'Raj Kumar',
    location: 'Selangor',
    invested: 'RM 100,000',
    progress: 45,
    returns: 'RM 15,000'
  }];
  const upcomingPayments = [{
    id: 1,
    project: 'Sustainable Rice Farming',
    amount: 'RM 24,000',
    date: '2024-03-15',
    type: 'Dividend'
  }, {
    id: 2,
    project: 'Vertical Farming Technology',
    amount: 'RM 37,500',
    date: '2024-06-01',
    type: 'Milestone Payment'
  }, {
    id: 3,
    project: 'Aquaculture System',
    amount: 'RM 25,000',
    date: '2024-01-15',
    type: 'Milestone Payment'
  }];
  const recommendedProjects = [{
    id: 1,
    name: 'Organic Vegetable Farm',
    farmer: 'Siti Aminah',
    location: 'Johor',
    seeking: 'RM 280,000',
    roi: '14%',
    match: '95%'
  }, {
    id: 2,
    name: 'Smart Poultry Farm',
    farmer: 'David Tan',
    location: 'Perak',
    seeking: 'RM 350,000',
    roi: '16%',
    match: '92%'
  }, {
    id: 3,
    name: 'Sustainable Fishing',
    farmer: 'Ibrahim Hassan',
    location: 'Terengganu',
    seeking: 'RM 200,000',
    roi: '13%',
    match: '88%'
  }];
  return <UserLayout requiredUserType="investor" data-id="element-843">
      <div className="mb-6" data-id="element-844">
        <h1 className="text-2xl font-bold text-soil-brown flex items-center" data-id="element-845">
          <LayoutDashboard size={24} className="mr-2" data-id="element-846" />
          Investor Dashboard
        </h1>
        <p className="text-gray-600" data-id="element-847">
          Welcome back to your investment portfolio
        </p>
      </div>
      {/* Portfolio Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-848">
        {portfolioStats.map((stat, index) => <div key={index} className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-leaf-green" data-id="element-849">
            <div className="flex justify-between items-start" data-id="element-850">
              <div data-id="element-851">
                <p className="text-sm text-gray-500" data-id="element-852">{stat.title}</p>
                <h3 className="text-2xl font-bold mt-1" data-id="element-853">{stat.value}</h3>
                <div className={`flex items-center mt-1 text-sm ${stat.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-854">
                  {stat.isPositive ? <ArrowUpRight size={14} className="mr-1" data-id="element-855" /> : <ArrowDownRight size={14} className="mr-1" data-id="element-856" />}
                  <span data-id="element-857">{stat.change} from last month</span>
                </div>
              </div>
              <div className="p-2 bg-gray-100 rounded-full" data-id="element-858">{stat.icon}</div>
            </div>
          </div>)}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-859">
        {/* Active Investments */}
        <div className="lg:col-span-2" data-id="element-860">
          <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-861">
            <div className="flex justify-between items-center mb-4" data-id="element-862">
              <h2 className="text-lg font-semibold" data-id="element-863">Active Investments</h2>
              <button className="text-sm text-leaf-green hover:underline" data-id="element-864">
                View all
              </button>
            </div>
            <div className="space-y-4" data-id="element-865">
              {activeInvestments.map(investment => <div key={investment.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow" data-id="element-866">
                  <div className="flex justify-between items-start" data-id="element-867">
                    <div data-id="element-868">
                      <h3 className="font-medium" data-id="element-869">{investment.name}</h3>
                      <p className="text-sm text-gray-600" data-id="element-870">
                        {investment.farmer} • {investment.location}
                      </p>
                    </div>
                    <span className="text-sm font-medium" data-id="element-871">
                      Invested: {investment.invested}
                    </span>
                  </div>
                  <div className="mt-3" data-id="element-872">
                    <div className="flex justify-between text-sm mb-1" data-id="element-873">
                      <span data-id="element-874">Progress</span>
                      <span data-id="element-875">{investment.progress}%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-876">
                      <div className="bg-leaf-green h-2 rounded-full" style={{
                    width: `${investment.progress}%`
                  }} data-id="element-877"></div>
                    </div>
                  </div>
                  <div className="mt-3 flex justify-between" data-id="element-878">
                    <div className="text-sm" data-id="element-879">
                      <span className="text-gray-600" data-id="element-880">Returns to date:</span>
                      <span className="font-medium ml-1 text-green-600" data-id="element-881">
                        {investment.returns}
                      </span>
                    </div>
                    <button className="text-sm text-leaf-green hover:underline" data-id="element-882">
                      Details
                    </button>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Recommended Projects */}
          <div className="bg-white rounded-lg shadow-sm p-4 mt-6" data-id="element-883">
            <div className="flex justify-between items-center mb-4" data-id="element-884">
              <h2 className="text-lg font-semibold flex items-center" data-id="element-885">
                <Search size={18} className="mr-2 text-leaf-green" data-id="element-886" />
                Recommended Projects
              </h2>
              <button className="text-sm text-leaf-green hover:underline" data-id="element-887">
                View more
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-888">
              {recommendedProjects.map(project => <div key={project.id} className="border border-gray-200 rounded-lg p-3 hover:border-leaf-green transition-colors" data-id="element-889">
                  <div className="flex items-center mb-2" data-id="element-890">
                    <div className="bg-leaf-green/10 p-1 rounded-full mr-2" data-id="element-891">
                      <SproutIcon size={16} className="text-leaf-green" data-id="element-892" />
                    </div>
                    <span className="text-xs py-0.5 px-2 bg-green-100 text-green-800 rounded-full" data-id="element-893">
                      {project.match} Match
                    </span>
                  </div>
                  <h3 className="font-medium text-soil-brown" data-id="element-894">
                    {project.name}
                  </h3>
                  <p className="text-xs text-gray-600 mb-2" data-id="element-895">
                    {project.farmer} • {project.location}
                  </p>
                  <div className="flex justify-between text-sm" data-id="element-896">
                    <span className="text-gray-600" data-id="element-897">Seeking</span>
                    <span className="font-medium" data-id="element-898">{project.seeking}</span>
                  </div>
                  <div className="flex justify-between text-sm mt-1" data-id="element-899">
                    <span className="text-gray-600" data-id="element-900">Est. ROI</span>
                    <span className="font-medium text-green-600" data-id="element-901">
                      {project.roi}
                    </span>
                  </div>
                  <button className="w-full mt-3 py-1 text-sm text-leaf-green border border-leaf-green rounded-md hover:bg-leaf-green/10" data-id="element-902">
                    View Details
                  </button>
                </div>)}
            </div>
          </div>
        </div>
        {/* Sidebar Content */}
        <div className="lg:col-span-1" data-id="element-903">
          {/* Upcoming Payments */}
          <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-904">
            <div className="flex justify-between items-center mb-4" data-id="element-905">
              <h2 className="text-lg font-semibold flex items-center" data-id="element-906">
                <CalendarIcon size={18} className="mr-2 text-amber-600" data-id="element-907" />
                Upcoming Payments
              </h2>
              <button className="text-sm text-leaf-green hover:underline" data-id="element-908">
                View all
              </button>
            </div>
            <div className="space-y-3" data-id="element-909">
              {upcomingPayments.map(payment => <div key={payment.id} className="flex items-center p-2 border-l-4 border-amber-400 bg-amber-50 rounded-r-md" data-id="element-910">
                  <div className="flex-1" data-id="element-911">
                    <p className="font-medium text-sm" data-id="element-912">{payment.project}</p>
                    <div className="flex justify-between mt-1" data-id="element-913">
                      <span className="text-xs text-gray-600" data-id="element-914">
                        {new Date(payment.date).toLocaleDateString('en-MY', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric'
                    })}
                      </span>
                      <span className="text-xs bg-blue-100 text-blue-800 px-1.5 py-0.5 rounded" data-id="element-915">
                        {payment.type}
                      </span>
                    </div>
                  </div>
                  <div className="ml-4 text-right" data-id="element-916">
                    <p className="font-bold text-green-600" data-id="element-917">{payment.amount}</p>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Portfolio Performance */}
          <div className="bg-white rounded-lg shadow-sm p-4 mt-6" data-id="element-918">
            <div className="flex justify-between items-center mb-4" data-id="element-919">
              <h2 className="text-lg font-semibold flex items-center" data-id="element-920">
                <LineChart size={18} className="mr-2 text-purple-600" data-id="element-921" />
                Portfolio Performance
              </h2>
            </div>
            <div className="space-y-4" data-id="element-922">
              <div className="h-40 bg-gray-100 rounded-lg flex items-center justify-center" data-id="element-923">
                <p className="text-gray-500" data-id="element-924">Portfolio chart placeholder</p>
              </div>
              <div className="grid grid-cols-2 gap-3" data-id="element-925">
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-926">
                  <p className="text-xs text-gray-500" data-id="element-927">Current Value</p>
                  <p className="text-lg font-bold" data-id="element-928">RM 518,500</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-lg" data-id="element-929">
                  <p className="text-xs text-gray-500" data-id="element-930">Initial Investment</p>
                  <p className="text-lg font-bold" data-id="element-931">RM 450,000</p>
                </div>
              </div>
              <button className="w-full py-2 text-sm text-white bg-leaf-green rounded-md hover:bg-leaf-green/90" data-id="element-932">
                View Detailed Analytics
              </button>
            </div>
          </div>
        </div>
      </div>
    </UserLayout>;
};